import Vue from 'vue'

export default {

    computed: {

        $isCreating: function() {

            return this.$route.params.id === 'create'

        },

        $isAdmin: function() {
        
            return this.$store.getters['type'] === this.$constants.userType.admin

        },

        $isOrganisation: function() {
        
            return this.$store.getters['type'] === this.$constants.userType.organisation

        },

        $isClinic: function() {
        
            return this.$store.getters['type'] === this.$constants.userType.clinic

        },

        $isData: function() {
        
            return this.$store.getters['type'] === this.$constants.userType.data

        },

        $keyPath: function() {

			return this.$route.meta.keyPath || this.$route.path

		}
    
    },

    methods: {

        $success: function(message) {
        
            this.$notify({
                message: message
            })

        },

        $failure: function(message) {
        
            this.$notify({
                message: message,
                type: 'error'
            })

        },
    
        $notify: function(config) {

            if (!this.$_.isObject(config)) config = { message: config }

			if (this.$_.isArray(config.message)) config.message = config.message.join(' ')

			config.message = config.message.replace(' .', '.')

			Vue.$toast.open(config)

		},
    
    }

}